<input
  class="form-control"
  name="dp"
  ngbDatepicker
  [(ngModel)]="ngbDate"
  [minDate]="ngbMinDate"
  [maxDate]="ngbMaxDate"
  (dateSelect)="change($event)"
  (focusout)="change(ngbDate)"
  (keyup.enter)="change(ngbDate)"
  [readOnly]="disabled"
  [firstDayOfWeek]="firstDayOfWeek"
  weekdays="short"
  navigation="arrows"
  [showWeekNumbers]="showWeekNumbers"
  [footerTemplate]="showFooter ? footerTpl : null"
  placement="bottom-end"
  #d="ngbDatepicker"
  />
  @if (!disabled) {
    <div class="date-icon-container" (click)="d.toggle()">
      <sb-icon name="date"></sb-icon>
    </div>
  }

  <ng-template #footerTpl>
    <div class="ngb-dp-footer">
      <button type="button" class="btn btn-sm btn-info" (click)="setToday()">{{ 'SB_Today' | translate }}</button>
      <button type="button" class="btn btn-sm btn-danger" (click)="clearDate()">{{ 'SB_Clear' | translate }}</button>
      <button type="button" class="btn btn-sm btn-success" (click)="closePicker()">{{ 'SB_Close' | translate }}</button>
    </div>
  </ng-template>
